import { Address } from './address.model';
import { Balance } from './balance.model';
import { Configuration } from './configuration.model';
import { KYCFormAnswer } from './kyc-form-answer';
import { PrivyWallet } from './privy-wallet.model';
import { RainBalance } from './rain-balance.model';
import { UserOtp } from './user_otp.model';
import { VerificationAttempted } from './verification-attempted.model';
import { Verification } from './verification.model';
import { Wallet } from './wallet.model';

export enum LegalTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  BUSINESS = 'BUSINESS',
}

export class User {
  uuid!: string;
  email!: string;
  last_name!: string;
  first_name!: string;
  legal_type: 'INDIVIDUAL' | 'BUSINESS' | string = 'INDIVIDUAL';
  postal_code!: string;
  state!: string;
  phone_number_prefix!: string;
  phone_number!: string;
  account_status!: string;
  bridge_status!: string;
  account_creation_date!: string;
  noah_status!: string;
  noah_rejection_reasons!: string;
  rain_status!: string;
  rain_id!: string;
  rain_kyc_url!: string;
  rain_status_reason!: string;
  date_of_birth!: string;
  nationality!: string;
  pin_created_at!: string;
  created_at!: string;
  kyc_status!: string;
  proof_of_address_status!: string;
  has_proof_of_address!: boolean;
  proof_of_address?: string;
  proof_of_address_failure_reason!: string;
  bridge_uuid!: string;
  rejection_reasons!: string;
  wallet_provider!: string;
  has_accepted_bridge_terms!: boolean;
  has_paid_opening_fees!: boolean;
  has_accepted_rain_card_terms!: boolean;
  outgoing_transactions_limited!: boolean;
  is_frozen!: boolean;
  is_blacklisted!: boolean;
  can_bypass_uniqueness!: boolean;
  privy_wallet!: PrivyWallet;
  addresses: Address[] = [];
  balances: Balance[] = [];
  verification!: Verification;
  user_otp!: UserOtp;
  rain_balance!: RainBalance;
  wallets: Wallet[] = [];
  kyc_form_answers: KYCFormAnswer[] = [];
  configuration!: Configuration;
  verifications_attempted!: VerificationAttempted;

  constructor(data: any = {}) {
    this.build(data);
  }

  private build(data: any = {}) {
    this.uuid = data.uuid;
    this.email = data.email;
    this.last_name = data.last_name;
    this.first_name = data.first_name;
    this.legal_type = data.legal_type || 'INDIVIDUAL';
    this.phone_number_prefix = data.phone_number_prefix;
    this.phone_number = data.phone_number;
    this.account_status = data.account_status;
    this.bridge_status = data.bridge_status;
    this.account_creation_date = data.account_creation_date;
    this.noah_status = data.noah_status;
    this.noah_rejection_reasons = data.noah_rejection_reasons;
    this.rain_status = data.rain_status;
    this.rain_id = data.rain_id;
    this.rain_kyc_url = data.rain_kyc_url;
    this.rain_status_reason = data.rain_status_reason;
    this.has_paid_opening_fees = data.has_paid_opening_fees;
    this.has_accepted_rain_card_terms = data.has_accepted_rain_card_terms;
    this.date_of_birth = data.date_of_birth;
    this.bridge_uuid = data.bridge_uuid;
    this.rejection_reasons = data.rejection_reasons;
    this.nationality = data.nationality;
    this.pin_created_at = data.pin_created_at;
    this.created_at = data.created_at;
    this.kyc_status = data.kyc_status;
    this.proof_of_address_status = data.proof_of_address_status;
    this.has_proof_of_address = Boolean(data.has_proof_of_address ?? data.proof_of_address);
    this.proof_of_address = data.proof_of_address;
    this.proof_of_address_failure_reason = data.proof_of_address_failure_reason;
    this.wallet_provider = data.wallet_provider;
    this.is_frozen = data.is_frozen;
    this.has_accepted_bridge_terms = data.has_accepted_bridge_terms;
    const rawList =
      data.addresses && data.addresses.length > 0
        ? data.addresses
        : data.address
        ? [data.address]
        : [];
    if (data.address && rawList.length > 0) {
      rawList[0] = { ...rawList[0], ...data.address };
    }
    this.addresses = rawList.map(
      (a: any) => (a instanceof Address ? a : new Address(a)),
    );
    this.balances = data.balances;
    this.wallets = data.wallets;
    this.kyc_form_answers = data.kyc_form_answers;
    this.verification = data.verification
      ? data.verification instanceof Verification
        ? data.verification
        : new Verification(data.verification)
      : data.verification;
    this.user_otp = data.user_otp;
    this.configuration = data.configuration;
    this.rain_balance = data.rain_balance;
    this.verifications_attempted = data.verifications_attempted;
    this.outgoing_transactions_limited = data.outgoing_transactions_limited;
    this.is_blacklisted = data.is_blacklisted;
    this.can_bypass_uniqueness = data.can_bypass_uniqueness;
    this.privy_wallet = data.privy_wallet ? new PrivyWallet(data.privy_wallet) : data.privy_wallet;
  }
}
